
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56.6 56.6"}},[_c('path',{attrs:{"d":"M56.6 7.1L49.5 0 28.3 21.2 7.1 0 0 7.1l21.2 21.2L0 49.5l7.1 7.1 21.2-21.2 21.2 21.2 7.1-7.1-21.2-21.2z"}})])
      }
    
      }
    